var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceRoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.104,
    height: 47.227,
    viewBox: "0 0 78.104 47.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38720",
    "data-name": "\\uADF8\\uB8F9 38720",
    transform: "translate(1.3 1.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_53",
    "data-name": "\\uC0AC\\uAC01\\uD615 53",
    width: 24.767,
    height: 44.627,
    rx: 4,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_5",
    "data-name": "\\uD0C0\\uC6D0 5",
    cx: 2.278,
    cy: 2.278,
    r: 2.278,
    transform: "translate(5.47 20.035)",
    fill: "#1a1311",
    stroke: "#000c7a",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_55",
    "data-name": "\\uC0AC\\uAC01\\uD615 55",
    width: 24.767,
    height: 44.627,
    rx: 4,
    transform: "translate(50.737 0)",
    fill: "none",
    stroke: "#f09",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_6",
    "data-name": "\\uD0C0\\uC6D0 6",
    cx: 2.278,
    cy: 2.278,
    r: 2.278,
    transform: "translate(56.208 20.035)",
    fill: "#1a1311",
    stroke: "#000c7a",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_54",
    "data-name": "\\uC120 54",
    y2: 11.213,
    transform: "translate(37.328 16.707)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_55",
    "data-name": "\\uC120 55",
    x1: 11.213,
    transform: "translate(31.721 22.313)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceRoom);
export default __webpack_public_path__ + "static/media/icon-service-room.607e3d7c18d4b51c5ab0c537047cd8d0.svg";
export { ForwardRef as ReactComponent };